import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../NewSettings.scss";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Menu, MenuItem } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import TabList from "../../../../../../Components/TabList/TabList";

function Modules() {
  const navigate = useNavigate();
  const [section, setSection] = useState<string>("general");
  const module_table = [
    {
      display_name: "Quotes",
      module_name: "Quotes",
      last_modified: "November 29, 2022",
      url: "images/module_img.svg",
    },
    {
      display_name: "Policy",
      module_name: "Policy",
      last_modified: "November 29, 2022",
      url: "images/module_img.svg",
    },
    {
      display_name: "Claims",
      module_name: "Claims",
      last_modified: "November 29, 2022",
      url: "images/module_img.svg",
    },
  ];
  const [show, setShow] = React.useState(false);
  const [subSection, setSubSection] = React.useState("businesscard");
  const [addQuoteStep, setAddQuoteStep] = React.useState<
    Array<{ insurer: string; premium: string; deleteable: boolean }>
  >([{ insurer: "", premium: "", deleteable: false }]);

  var indents = [];
  for (var i = 0; i < addQuoteStep.length; i++) {
    indents.push(<span className="indent" key={i}></span>);
  }
  const [activePage, setActivePage] = useState("dashboard");

  // function updateMasterState(attrName: string, value: any) {
  //   switch (attrName) {
  //     case "activePage":
  //       setActivePage(value);
  //       break;
  //     default:
  //       console.log(attrName, value);
  //       break;
  //   }
  // }
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  // for scrolling
  const currencies = useRef(null);
  const company = useRef(null);
  const branches = useRef(null);
  const departments = useRef(null);
  const taxation = useRef(null);
  const personal = useRef(null);
  const email = useRef(null);
  const appearance = useRef(null);
  const users = useRef(null);
  const access = useRef(null);
  const modules = useRef(null);
  const templates = useRef(null);
  const employee = useRef(null);
  const employer = useRef(null);
  const storage = useRef(null);
  const exports = useRef(null);
  const activitylog = useRef(null);
  const auditlog = useRef(null);
  const integration = useRef(null);
  const webhooks = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box className="settingMenuWrapper">
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="rightSection">
              <Box className="detailSection">
                <Grid container spacing={3}>
                  <Grid xs={12} style={{ paddingBottom: "0", paddingTop: "0" }}>
                    <ul className="moduleHeading">
                      <li>Display Name</li>
                      <li>Module Name</li>
                      <li>Last Modified</li>
                    </ul>
                  </Grid>
                  {module_table.map((data, index) => (
                    <>
                      <Grid
                        xs={12}
                        style={{ paddingTop: "0px", paddingBottom: "0" }}>
                        <ul className="module_list">
                          <li>
                            <Link className="moduleLink">
                              {data.display_name}
                            </Link>
                            <ul className="module_sublist">
                              <li>
                                <Link
                                  className="Sublist_module"
                                  onClick={() => navigate("/customModules")}>
                                  Health
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="Sublist_module"
                                  onClick={() => navigate("/customModules")}>
                                  Term
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="Sublist_module"
                                  onClick={() => navigate("/customModules")}>
                                  Critical Illness
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li>{data.module_name}</li>
                          <li>
                            <img src={data.url} />
                            {data.last_modified}
                          </li>
                        </ul>
                      </Grid>
                      <Grid xs={12} className="mb-0 pt-0 pb-0">
                        {index + 1 === module_table.length ? null : (
                          <hr className="mb-0" />
                        )}
                      </Grid>
                    </>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Modules;
